import { useEffect } from 'react';
import { acquireSocket, releaseSocket, type StatusSummary } from '@/shared/api';
import { useAuthStore } from '@/features/auth';
import { useSystemStatusStore } from './system-status-store';

const FALLBACK_POLL_MS = 120_000;

export function useSystemStatusLive(): void {
  const isStaff = useAuthStore((s) => s.isAuthenticated && s.hasPermission('view_tickets'));

  useEffect(() => {
    if (!isStaff) return;
    const { refresh, set } = useSystemStatusStore.getState();
    void refresh();

    let cancelled = false;
    let socket: Awaited<ReturnType<typeof acquireSocket>> = null;
    const onStatus = (summary: StatusSummary) => set(summary);
    const onConnect = () => void refresh();
    void acquireSocket().then((s) => {
      if (cancelled || !s) return;
      socket = s;
      s.on('system_status', onStatus);
      s.on('connect', onConnect);
    });

    const onVisible = () => {
      if (document.visibilityState === 'visible') void refresh();
    };
    document.addEventListener('visibilitychange', onVisible);
    const timer = window.setInterval(() => {
      if (document.visibilityState === 'visible') void refresh();
    }, FALLBACK_POLL_MS);

    return () => {
      cancelled = true;
      socket?.off('system_status', onStatus);
      socket?.off('connect', onConnect);
      releaseSocket();
      document.removeEventListener('visibilitychange', onVisible);
      window.clearInterval(timer);
    };
  }, [isStaff]);
}
